export const VEHICLE_TYPES = {
    CAR: 'car',
    MOTORCYCLE: 'motorcycle'
} as const;

export const AUTH_METHODS = {
    ALREADY_LOGGED_IN: 'already_logged_in',
    OTP_VERIFIED: 'otp_verified'
} as const;

export const BUDGET_RANGES = {
    UNDER_1B: 'UNDER_1B',
    FROM_1B_TO_2B: '1B_TO_2B',
    FROM_2B_TO_4B: '2B_TO_4B',
    FROM_4B_TO_7B: '4B_TO_7B',
    OVER_7B: 'OVER_7B'
} as const;

export const FINES_INQUIRY_TYPES = {
    FINAL_AMOUNT: 'final_amount',
    ITEMIZED: 'itemized'
} as const;

export const INQUIRY_PAYMENT_METHODS = {
    ONLINE: 'online',
    DIGIPAY_INSTALLMENT: 'digipay_installment',
    BLUBANK_CREDIT: 'blubank_credit'
} as const;

export const INSPECTION_PAYMENT_METHODS = {
    CASH: 'cash',
    INSTALLMENT: 'installment'
} as const;

export const BATTERY_PAYMENT_METHODS = {
    CASH: 'cash',
    INSTALLMENT: 'installment'
} as const;

export const EXPERT_PACKAGES = {
    STANDARD: 'STANDARD',
    ZERO_MILEAGE: 'ZERO_MILEAGE',
    PAINT_AND_BODY: 'PAINT_AND_BODY'
} as const;

export const BILL_TYPES = {
    FREEWAY_TOLL: 'freeway_toll',
    TRAFFIC_PLAN: 'traffic_plan',
    VEHICLE_FINES: 'vehicle_fines'
} as const;

export const ADDRESS_ACTIONS = {
    NEW: 'new',
    EDIT: 'edit',
    UNCHANGED: 'unchanged'
} as const;

export const ECOMMERCE_CURRENCY = 'IRR' as const;

export const ECOMMERCE_ITEM_BRAND = 'azkiservice' as const;
